import React, { useEffect, useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
function Counter({
  from,
  to,
  suffix = '',
  duration = 2
}) {
  const [count, setCount] = useState(from);
  const nodeRef = useRef(null);
  const inView = useInView(nodeRef, {
    once: true,
    margin: '-50px'
  });
  useEffect(() => {
    if (inView) {
      let startTime: number;
      let animationFrame: number;
      const animate = (timestamp: number) => {
        if (!startTime) startTime = timestamp;
        const progress = Math.min((timestamp - startTime) / (duration * 1000), 1);
        const ease = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
        setCount(Math.floor(from + (to - from) * ease));
        if (progress < 1) animationFrame = requestAnimationFrame(animate);
      };
      animationFrame = requestAnimationFrame(animate);
      return () => cancelAnimationFrame(animationFrame);
    }
  }, [inView, from, to, duration]);
  return <span ref={nodeRef} data-id="element-226">
      {count.toLocaleString()}
      {suffix}
    </span>;
}
export function ImpactNumbers() {
  return <section className="py-8 sm:py-12 md:py-16 lg:py-20 bg-gray-50" data-id="element-227">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-228">
        <div className="rounded-2xl sm:rounded-[2rem] md:rounded-[3rem] bg-white p-6 sm:p-8 md:p-12 lg:p-20 shadow-xl shadow-gray-200/50" data-id="element-229">
          <div className="grid grid-cols-3 gap-4 sm:gap-8 md:gap-12 text-center divide-x divide-gray-100" data-id="element-230">
            {/* Metric 1 */}
            <div className="flex flex-col items-center" data-id="element-231">
              <div className="mb-1 sm:mb-2 text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600" data-id="element-232">
                <Counter from={0} to={+150} suffix="+" data-id="element-233" />
              </div>
              <p className="text-xs sm:text-sm md:text-base lg:text-lg font-semibold text-gray-500" data-id="element-234">
                Obras entregadas
              </p>
            </div>

            {/* Metric 2 */}
            <div className="flex flex-col items-center" data-id="element-235">
              <div className="mb-1 sm:mb-2 text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600" data-id="element-236">
                <Counter from={0} to={40} data-id="element-237" />
              </div>
              <p className="text-xs sm:text-sm md:text-base lg:text-lg font-semibold text-gray-500" data-id="element-238">
                Años de experiencia
              </p>
            </div>

            {/* Metric 3 */}
            <div className="flex flex-col items-center" data-id="element-239">
              <div className="mb-1 sm:mb-2 text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600" data-id="element-240">
                <Counter from={0} to={75} suffix="K+" data-id="element-241" />
              </div>
              <p className="text-xs sm:text-sm md:text-base lg:text-lg font-semibold text-gray-500" data-id="element-242">
                m² habilitados
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}